import { render, staticRenderFns } from "./fashion-banner.vue?vue&type=template&id=6ff6f2cd&scoped=true"
import script from "./fashion-banner.vue?vue&type=script&lang=js"
export * from "./fashion-banner.vue?vue&type=script&lang=js"
import style0 from "./fashion-banner.vue?vue&type=style&index=0&id=6ff6f2cd&prod&scoped=true&lang=css"
import style1 from "./fashion-banner.vue?vue&type=style&index=1&id=6ff6f2cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6f2cd",
  null
  
)

export default component.exports